import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

class ErrorView extends Component {

  componentWillMount() {
    const { store, history } = this.props;
    if (!store.errors.length) {
      history.push('/');
    }
  }

  render() {
    const { store } = this.props;
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="alert alert-danger" role="alert">
                An error was encountered when processing your order.
            </div>
            <p>
              Error message: {store.errors[0]}
            </p>
          </div>
        </div>
      </div>
    );
  }

}

export default withRouter(inject('store')(observer(ErrorView)));



// WEBPACK FOOTER //
// ./src/views/ErrorView.js